import { useEffect, useState } from 'react';
import { api } from '../../../../lib/api';

interface ErrorRow {
  id: string;
  level: string;
  source: string;
  message: string;
  route: string | null;
  method: string | null;
  status_code: number | null;
  resolved: number;
  created_at: string;
}

export function AdminErrorsPage() {
  const [rows, setRows] = useState<ErrorRow[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  async function load() {
    setLoading(true);
    try {
      const response = await fetch('/api/admin/errors', { credentials: 'same-origin' });
      const data = await response.json() as ErrorRow[] | { error?: string };
      if (!response.ok) throw new Error('error' in data ? data.error : 'Falha ao carregar erros.');
      setRows(data as ErrorRow[]);
      setError('');
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Erro ao carregar logs.');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { void load(); }, []);

  async function resolve(id: string) {
    await fetch('/api/admin/errors', {
      method: 'PATCH',
      credentials: 'same-origin',
      headers: { 'content-type': 'application/json' },
      body: JSON.stringify({ id }),
    });
    await load();
  }

  return (
    <section className="admin-section" aria-labelledby="errors-title">
      <div className="admin-section-head">
        <div>
          <span className="section-tag">OBSERVABILIDADE</span>
          <h2 id="errors-title">Erros e diagnósticos</h2>
        </div>
        <button type="button" className="btn btn-outline" onClick={() => void load()} disabled={loading}>
          {loading ? 'Atualizando…' : 'Atualizar'}
        </button>
      </div>
      {error && <p className="form-error" role="alert">{error}</p>}
      {!loading && rows.length === 0 && <p className="form-info">Nenhum erro registrado.</p>}
      <div className="admin-table-wrap">
        <table className="admin-table">
          <thead><tr><th>Data</th><th>Origem</th><th>Mensagem</th><th>HTTP</th><th>Status</th><th>Ação</th></tr></thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td>{new Date(row.created_at).toLocaleString('pt-BR')}</td>
                <td>{row.source}<br /><small>{row.route ?? '—'}</small></td>
                <td>{row.message}</td>
                <td>{row.status_code ?? '—'}</td>
                <td>{row.resolved ? 'Resolvido' : 'Aberto'}</td>
                <td>
                  {!row.resolved && (
                    <button type="button" className="btn btn-small btn-primary" onClick={() => void resolve(row.id)}>
                      Marcar resolvido
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
